import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';

import MyModal from '../../components/Modal/Modal';
import { addCommercialProduct, updateCommercialProduct } from '../../api/commercialProducts';

const NewCommercialProductModal = ({
  mode = "create",
  open = false,
  commercialProductData,
  refreshList = () => {},
  onClose = () => {},
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);
  const [modalMode, setModalMode] = useState(false);
	// processing is for user initiated component api calls
	const [processing, setProcessing] = useState(false);
  const [commercialProductInfo, setCommercialProductInfo] = useState(null);
  const [name, setName] = useState("");
  const [color, setColor] = useState("");

  const onlyAttachment = localStorage.getItem('only_attachment')

  useEffect(() => setModalMode(mode), [mode]);
  useEffect(() => {
    if(commercialProductData){
      setCommercialProductInfo(commercialProductData);
      setName(commercialProductData?.name);
      setColor(commercialProductData?.additional_info?.color);
    }
    else{
      setName("");
      setColor("");
    }
  }, [commercialProductData]);
  const addBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const onChangeName = (input) => {
    setName(input);
  };

  const onChangeColor = (input) => {
    setColor(input)
  }

  const saveCommercialProduct = (e) => {
    e.preventDefault();
    
    if (!name) {
      toaster("Please enter name", "warning")
      return;
    }
    
    setProcessing(true);
    if(modalMode === "create"){
      let params = {
        name: name,
        additional_info: {
          color: color
        }
      }
      addCommercialProduct(params).then(res => {
        toaster("Created new commercial product", "success")
        setName("");
        setColor("")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to create new commercial product", "error")
        setProcessing(false);
      });
    } else{
      updateCommercialProduct(commercialProductInfo.id, {
        name:name,
        additional_info: {
          color: color
        }
      }).then(res =>{
        toaster("Commercial product updated successfully", "success")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to update global commercialProduct", "error")
        setProcessing(false);
      });;
    };
  }

  
	const additionalProps = {
		className: 'some-class',
		onSubmit: saveCommercialProduct
	};
  
  return (
    <MyModal
      modalHeading="Commercial Product Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ModalContent>

      {
					processing || loading ? 
					<Loading/> 
					:
					<></>
				}
				
				<Form {...additionalProps}>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              value={name}
              labelText="Commercial Product Name*"
              // placeholder="Please enter CommercialProduct Name"
              onChange={e => onChangeName(e.target.value)}
              required
            />
          </div>
          <div style={{ marginBottom: "18px", display: "flex", flexDirection: "column" }}>
            <CustomLabel>Color</CustomLabel>
            <input
              value={color}
              type="color"
              onChange={e => onChangeColor(e.target.value)}
            />
          </div>


          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => onCreate()}
              style={addBtnStyle}  
              disabled={onlyAttachment === "true"}
            >{ (modalMode === "create") ? "Create Commercial Product" : "Update Commercial Product" }</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default NewCommercialProductModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const CustomLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.33333;
  letter-spacing: 0.32px;
  display: inline-block;
  margin-bottom: 0.5rem;
  color: #525252;
  font-weight: 400;
  line-height: 1rem;
  vertical-align: baseline;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
